<template>

  <!-- Announce Events Grid Block -->
  <items-loader
    no-autoload
    module="vlAnnounceEvents"
    class="announce-events-grid-block">

    <template
      slot-scope="{items, loading, hasMore, loadMore}">

      <page-block
        bg-image-contain
        v-if="items.length"
        :bg-file="value.file"
        :bg-color="value.bgColor"
        :text-color="value.textColor"
        :text-align="value.textAlign"
        :width-class="value.widthClass"
        :overlay-class="value.paddingClass">

        <titled-text-element
          no-file
          no-body
          :value="value"/>

        <div
          class="ibs-mt hide-last hide-first"/>

        <div
          class="grid-5 grid-gap-3">

          <universal-link
            :key="item.id"
            v-for="item in items"
            :to="`/event/${item.slug}`">

            <announce-event-card
              :value="item"
              class="hover-scale-2"/>

          </universal-link>

        </div>

        <q-btn
          rounded
          unelevated
          color="accent"
          v-if="hasMore"
          @click="loadMore"
          :loading="loading"
          class="block-btn bs-mt max-width-100 no-wrap q-mb-none q-mx-auto block">
          Загрузить еще
        </q-btn>

      </page-block>

    </template>

  </items-loader>

</template>

<script>

  import {mapActions, mapMutations} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import TitledTextElement from '@src/components/element/titled-text-element';
  import AnnounceEventCard from '@src/components/card/announce-event-card';

  export default {
    name: 'announce-events-grid-block',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      AnnounceEventCard,
      TitledTextElement,
    },
    methods: {
      ...mapActions('vlAnnounceEvents', {
        fetch: 'FETCH_ITEMS',
      }),
      ...mapMutations('vlAnnounceEvents', {
        setWhere: 'SET_WHERE',
      }),
    },
    mounted() {

      this.setWhere({
        published: true,
        notListed: {neq: true},
        startDate: {gt: new Date().toISOString()},
        publishedAt: {lte: new Date().toISOString()},
        public: this.$store.getters['session/isLoggedIn']
          ? undefined
          : true,
      });

      this.fetch();
    },
  };

</script>

<style lang="scss">

  .announce-events-grid-block {
    color: inherit;

    .titled-text-element {
      position: relative;
    }

    .titled-text-element:after {
      content: '';
      top: 16px;
      left: -125px;
      width: 135px;
      height: 44px;
      position: absolute;
      transform: scale(.8);
      background: url('/images/element/element-head-short.svg');

      @media (max-width: $breakpoint-xs) {
        display: none;
      }
    }
  }

</style>
